import { render, staticRenderFns } from "./wocanyude.vue?vue&type=template&id=32cf3ba8&scoped=true"
import script from "./wocanyude.vue?vue&type=script&lang=js"
export * from "./wocanyude.vue?vue&type=script&lang=js"
import style0 from "./wocanyude.vue?vue&type=style&index=0&id=32cf3ba8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cf3ba8",
  null
  
)

export default component.exports